import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/edit`;

export const ROUTE: RouteDefinition = `${baseRoute}/edit`;

export const URL = (): RouteDefinition => `${baseRoute}/edit`;
